import { useAlertMarkersVisibility } from '../../hooks/useAlertMarkersVisibility'

interface Props {
  className?: string
  markerCount?: number
}

export function AlertMarkersToggle({ className = '', markerCount }: Props) {
  const { visible, toggle } = useAlertMarkersVisibility()

  const label = markerCount !== undefined && markerCount > 0
    ? `Alert Markers (${markerCount})`
    : 'Alert Markers'

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={visible}
      title={visible ? 'Hide alert markers on charts' : 'Show alert markers on charts'}
      className={[
        'px-3 py-1.5 text-xs font-medium rounded-md border transition-colors',
        visible
          ? 'bg-blue-50 text-blue-700 border-blue-300 hover:bg-blue-100'
          : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50',
        className,
      ].join(' ')}
    >
      {label}
    </button>
  )
}
